import ConnectionAdapter from "../adapters/connection_adapter";
import DocumentAdapter from "../adapters/document_adapter";
import localStorageAdapter from "../adapters/localstorage_adapter";
import VolumeStateService from "../service/volume_state_service";
import URLUtils from "../utils/url_utils";

export default class AdTag {
  constructor(uri) {
    this._uri = "";
    this._adUnit = "";
    this._adSize = "";
    if (!uri) return;

    const tag = this._validateUri(uri);
    if (!tag) return;

    this._uri = tag;
    this._adUnit = URLUtils.getQueryParam(this._uri, "iu");
    this._adSize = URLUtils.getQueryParam(this._uri, "sz");
  }

  _validateUri(uri) {
    try {
      decodeURIComponent(uri);
    } catch (e) {
      uri = "";
    }
    return uri;
  }

  getAdTag() {
    return this._uri;
  }

  getAdUnit() {
    return this._adUnit;
  }

  getAdSize() {
    return this._adSize;
  }

  setAdTag(uri) {
    this._uri = uri;
  }

  isVmap() {
    const tag = this.getAdTag();
    const isOutputVast = tag.indexOf('output=vmap') >= 0;
    const isAdRule1 = tag.indexOf('ad_rule=1') >= 0;
    return isOutputVast && isAdRule1;
  }

  addNetworkTypeToAdTag() {
    let tag = this.getAdTag();

    if (ConnectionAdapter.hasNetworkInformationObject()) {
      const connType = ConnectionAdapter.type();
      if (connType != undefined) {
        tag = URLUtils.addQueryParam(tag, "con", connType);
      }
    }
    this._uri = tag;
    return this;
  }

  addVidioEmbedSite(isEmbedSite = "false") {
    if (isEmbedSite == "false") return this;

    let tag = this.getAdTag();
    const hostname = DocumentAdapter.referrer().match(
      /^(?:https?:\/\/)?(?:[^@\n]+@)?([^:/\n]+)/im
    );
    const referer = hostname !== null ? hostname[1] : "null";
    const custParamsIndex = tag.indexOf("cust_params=");

    if (custParamsIndex < 0) {
      tag = URLUtils.addQueryParam(tag, "cust_params", "");
    }

    this._uri = tag.replace("cust_params=", `cust_params=vidio_embed_site%3D${encodeURIComponent(referer)}%26`);
    return this;
  }

  replaceVidioMuted(muted) {
    let tag = this.getAdTag();

    const localStorageVolumeState = localStorageAdapter().getItem(
      VolumeStateService.muteStorageName()
    );
    const state = localStorageVolumeState ? localStorageVolumeState : muted;
    this._uri = tag.replace("[$vidioMuted$]", state);

    return this;
  }

  setChildDirectedTreatment() {
    const isKidsModeActive = localStorageAdapter().getItem("kids") == "true";

    let tag = this.getAdTag();
    if (isKidsModeActive) {
      tag = URLUtils.addQueryParam(tag, "tfcd", "1");
    }

    this._uri = tag;
    return this;
  }
}
